module.exports = __webpack_public_path__ + "01f43047/img/comment-question-icon.7dd26e04.svg";